import Component from '../components/Component';

/**
 * 地图控制器基类，控制器主要用于控制更小粒度的元件对象
 */
export default class Controller extends Component {
    /**
     * 构造方法
     * @returns {undefined}
     */
    constructor(options) {
        super(options);

        /**
         * 反馈容器，存储所有添加到本对象的反馈
         * @type {Array}
         */
        this.elements = [];
    }

    /**
     * 添加元件
     * @param {Object} element 元件对象
     * @return {undefined}
     */
    add(element) {
        const existed = this.elements.find(item => item === element);
        if (existed) {
            return;
        }

        element.onAdd(this);

        this.elements.push(element);
    }

    /**
     * 删除元件
     * @param {Object} element 元件对象
     * @return {undefined}
     */
    delete(element) {
        const existIndex = this.elements.indexOf(element);
        if (existIndex >= 0) {
            this.elements[existIndex].onRemove();

            this.elements.splice(existIndex, 1);
        }
    }

    /**
     * 清空所有元件
     * @return {undefined}
     */
    clear() {
        this.elements.forEach(item => {
            item.onRemove();
        });
        this.elements = [];
    }
}
